import React from 'react';

import { toast } from 'react-toastify';

import ToastError from 'lib/toast/error';
import ToastSuccess from 'lib/toast/success';

const options = {
  hideProgressBar: true,
  className: '!min-h-0 rounded-sm',
  bodyClassName: '!m-0 py-1 px-2.5',
  borderRadius: '2px',
  closeButton: <React.Fragment />,
};

export const toastSuccess = (title = '') => {
  return toast(<ToastSuccess title={title} />, { ...options });
};

export const toastError = (title = '') => {
  return toast(<ToastError title={title} />, { ...options });
};
